<script setup lang="ts">
import type { ProductionLineModel } from '@/types/models/ProductionLineModel'
import { BaseDialog, StackLayout, StringInputField } from '@rfc/rfc-components-library'

type Props = {
    open: boolean
    data: Partial<ProductionLineModel>
}
defineProps<Props>()
type Emits = {
    (e: 'close'): void
    (e: 'confirm'): void
    (e: 'change', data: Partial<ProductionLineModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <BaseDialog
        :open="open"
        :disabled="!data.name"
        :title="`${$t('common.edit')} — ${data?.name}`"
        @confirm="$emit('confirm')"
        @close="$emit('close')">
        <StackLayout direction="column" :gap="8">
            <StringInputField
                :modelValue="data.name"
                @change="$emit('change', { name: $event })"
                :label="$t('productionLine.model.name')"
                required />
            <slot />
        </StackLayout>
    </BaseDialog>
</template>
